export default __webpack_public_path__ + "static/media/score.9f62bca8.svg";